// 全局loading
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import store from "@/store";
import {
  rlJointData,
  rlGridData,
  rlGridArcData,
  rlAxisData,
  rlAxisArcData,
  rlWallData,
  rlWallHoleData,
  rlColumnData,
  rlRingBeamData,
  rlSlabData,
  rlSlabHoleData,
  rlSubBeamData,
  rlBeamData,
  rlPartitionWallData,
  rlDoorsWindowsData,
  rlUseData,
  rlJointCData,
  rlGridCData,
  rlAxisCData,
} from "@/rlMxModules/rlDataClass/index";

import {
  addEntityToDrawing,
  getEntityData,
  toggleAxisDist,
} from "@/rlMxModules/operate/operateApi";

import { generate_guid } from "@/rlMxModules/utils/util";

// 接口数据
import { getTotalFloorData } from "@/api/cadList";

import { initRevokeReDoData } from "@/rlMxModules/operate/revokeRollback";

// 数据库操作
import {
  getrlFloor,
  addrlStdFlr,
  getrlStdFlrAll,
  resetAllRlFloor,
  resetAllRlStdFlr,
  resetAllRlColSect,
  resetAllRlBeamSect,
  resetAllRlWallSect,
  resetAllRlSlabSect,
  resetAllrlPartitionWallSect,
  resetAllrlDoorsWindowsDef,
  resetAllRlLayer,
  getRlModules,
  getRlLayer,
  resetAllRlRingBeamSect,
  resetAllRlWallHoleDef,
  resetAllRlslabholedef,
  updateBulkRlStdFlrFieldDatas,
  delBulkRlStdFlrFieldDatas,
  getRlInitFloorData,
} from "@/mixins/LiteModuleDb.js";
import { getrlStdFlr } from "@/mixins/LiteModuleDb.js";

import { getNonStructuralColor } from "@/rlMxModules/operate/structural";

// 更新三维
import { update3Dview } from "@/rlMxModules/threeObject/threeView";
import { LOG } from "@zxing/library/esm/core/datamatrix/encoder/constants";
import mxcad from "mxcad";
const { McGePoint3d, McCmColor } = mxcad;
import { getArcPoints } from "@/rlMxModules/Opencascad/getModelDrawData.js";

//获取数据
export const initAllData = async () => {
  //接口获取数据 - 248
  try {
    // 自然层
    const rlfloorData = await getTotalFloorData("rlfloor");
    await resetAllRlFloor(rlfloorData.data);
    // 标准层
    const rlstdflrData = await getTotalFloorData("rlstdflr");
    await resetAllRlStdFlr(rlstdflrData.data);
    // 柱截面
    const rlcolsectData = await getTotalFloorData("rlcolsect");
    await resetAllRlColSect(rlcolsectData.data);
    // 梁截面
    const rlbeamsectData = await getTotalFloorData("rlbeamsect");
    await resetAllRlBeamSect(rlbeamsectData.data);
    // 墙截面
    const rlwallsectData = await getTotalFloorData("rlwallsect");
    await resetAllRlWallSect(rlwallsectData.data);
    // 板截面
    const rlslabsectData = await getTotalFloorData("rlslabsect");
    await resetAllRlSlabSect(rlslabsectData.data);
    // 墙洞截面
    const rlWallHoleDefData = await getTotalFloorData("rlWallHoleDef");
    await resetAllRlWallHoleDef(rlWallHoleDefData.data);
    // 圈梁截面
    const rlringbeamsectData = await getTotalFloorData("rlringbeamsect");
    await resetAllRlRingBeamSect(rlringbeamsectData.data);

    // 板洞数据
    const rlSlabHoleDefData = await getTotalFloorData("rlSlabHoleDef");
    await resetAllRlslabholedef(rlSlabHoleDefData.data);

    // 隔墙数据
    const rlPartitionWallSect = await getTotalFloorData("rlpartitionwallsect");
    await resetAllrlPartitionWallSect(rlPartitionWallSect.data);

    // 门窗数据
    const rlDoorsWindowsDef = await getTotalFloorData("rldoorswindowsdef");
    await resetAllrlDoorsWindowsDef(rlDoorsWindowsDef.data);

    // 图层
    const rllayerData = await getTotalFloorData("rllayer");
    await resetAllRlLayer(rllayerData.data);

    // 获取最大序号
    const rlstructnumData = await getTotalFloorData("maxNo");

    store.commit("globalData/setStructNum", rlstructnumData.data);
    return "新增成功";
  } catch (error) {
    return error;
  }
  //将数据分别存入indexdb
};

//绘制指定标准层的节点--草图
export const drawStdFlrJointCData = (jointData, currFlrLevelB) => {
  try {
    if (!jointData) return null;

    let jointKeyValue = {};
    let guids = Object.keys(jointData);
    let index = 0;
    let batchSize = 100; // 每批处理的实体数量，可根据实际情况调整

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = jointData[guid];

          if (dataObj) {
            let rlPointObj = new rlJointCData();
            rlPointObj.initData({
              m_pt: [dataObj["X"], dataObj["Y"], currFlrLevelB],
              StdFlrGuid: dataObj.StdFlrGuid,
              Guid: dataObj.Guid,
            });

            jointKeyValue[dataObj.Guid] = rlPointObj;

            // 将绘制操作添加到 promises 数组中，便于并发处理
            promises.push(addEntityToDrawing(rlPointObj, true));
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            // 使用 queueMicrotask 让出主线程
            queueMicrotask(processBatch);
          } else {
            resolve(jointKeyValue);
          }
        });
      }

      processBatch();
    });
  } catch (error) {
    console.error("绘制节点时出错：", error);
    return null;
  }
};

//绘制指定标准层的轴线--草图
export const drawStdFlrAxisCData = (axisData, jointKeyValue, gridData) => {
  try {
    if (!jointKeyValue || !axisData) return null;

    let axisKeyValue = {};
    let unvalidData = [];
    let guids = Object.keys(axisData);
    let index = 0;
    let batchSize = 100; // 批次处理大小

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = axisData[guid];

          if (!dataObj) continue;

          const jt1 = jointKeyValue[dataObj.Jt1Guid];
          const jt2 = jointKeyValue[dataObj.Jt2Guid];

          if (jt1 && jt2) {
            let rlAxisObj = null;
            if (dataObj.IsMainAxis == -1 && gridData) {
              let grid = Object.values(gridData).filter(
                (item) => item.AxisGuid == guid
              );

              if (grid && grid.length) {
                rlAxisObj = new rlAxisArcData();
                rlAxisObj.initData({
                  m_stJoint: jt1,
                  m_edJoint: jt2,
                  m_stArcPoint: getEntityData({
                    Guid: grid[0].Jt1Guid,
                    classTypeName: "rlJointC",
                  })?.m_pt,
                  m_edArcPoint: getEntityData({
                    Guid: grid[0].Jt2Guid,
                    classTypeName: "rlJointC",
                  })?.m_pt,
                  IsMainAxis: dataObj.IsMainAxis,
                  Name: dataObj.Name,
                  Guid: dataObj.Guid,
                  StdFlrGuid: dataObj.StdFlrGuid,
                  isShow: dataObj.IsShow,
                });
              }
            } else {
              rlAxisObj = new rlAxisCData();
              rlAxisObj.initData({
                m_stJoint: jt1,
                m_edJoint: jt2,
                IsMainAxis: dataObj.IsMainAxis,
                Name: dataObj.Name,
                Guid: dataObj.Guid,
                StdFlrGuid: dataObj.StdFlrGuid,
                isShow: dataObj.IsShow,
              });
            }
            if (rlAxisObj) {
              axisKeyValue[dataObj.Guid] = rlAxisObj;

              // 并行执行绘制操作
              promises.push(addEntityToDrawing(rlAxisObj, true));
            }
          } else {
            unvalidData.push(dataObj);
          }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            // 继续处理下一批数据
            queueMicrotask(processBatch);
          } else {
            // 所有批次完成，返回最终结果
            resolve({ axisKeyValue, unvalidData });
          }
        });
      }

      processBatch();
    });
  } catch (error) {
    console.error("绘制轴线时出错：", error);
    return null;
  }
};

//绘制指定标准层的网格--草图
export const drawStdFlrGridCData = async (
  gridData,
  jointKeyValue,
  axisKeyValue
) => {
  try {
    if (!jointKeyValue || !gridData) return null;

    // //添加一条假数据
    // gridData["11222222222"] = {
    //   Guid: "11222222222",
    //   AxisGuid: "poiuytrewq",
    //   Jt1Guid: "asdfghhjk",
    //   Jt2Guid: "qwerertuy",
    //   OtherData: "",
    //   StdFlrGuid: Object.keys(gridData)[0].StdFlrGuid,
    // };

    let gridKeyValue = {};
    let unvalidData = [];
    let guids = Object.keys(gridData);
    let index = 0;
    let batchSize = 100; // 每批处理的实体数量，可以根据实际情况调整

    return new Promise((resolve, reject) => {
      async function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = gridData[guid];

          // 减少判断的复杂度
          if (!dataObj) continue;
          const jt1 = jointKeyValue[dataObj.Jt1Guid];
          const jt2 = jointKeyValue[dataObj.Jt2Guid];

          if (jt1 && jt2) {
            let rlLineGridObj = null;
            // if (axis.IsMainAxis < 0) {
            //   rlLineGridObj = new rlGridArcData(); // 简化对象创建
            //   rlLineGridObj.initData({
            //     m_stJoint: jt1,
            //     m_edJoint: jt2,
            //     centerPoint: axis.m_stJoint.m_pt,
            //     StdFlrGuid: dataObj.StdFlrGuid,
            //     m_Axis: axis,
            //     Guid: dataObj.Guid,
            //   });
            // } else {
            //   rlLineGridObj = new rlGridCData(); // 简化对象创建
            //   rlLineGridObj.initData({
            //     m_stJoint: jt1,
            //     m_edJoint: jt2,
            //     StdFlrGuid: dataObj.StdFlrGuid,
            //     m_Axis: axis,
            //     Guid: dataObj.Guid,
            //   });
            // }
            rlLineGridObj = new rlGridCData(); // 简化对象创建
            rlLineGridObj.initData({
              m_stJoint: jt1,
              m_edJoint: jt2,
              StdFlrGuid: dataObj.StdFlrGuid,
              m_Axis: null,
              Guid: dataObj.Guid,
              Length: dataObj.Length,
              Thickness: dataObj.Thickness ? dataObj.Thickness : 0,
            });
            gridKeyValue[dataObj.Guid] = rlLineGridObj;

            promises.push(addEntityToDrawing(rlLineGridObj, true)); // 并发添加绘制
          } else {
            unvalidData.push(dataObj);
          }
        }
        await Promise.all(promises); // 当前批次的所有绘制操作完成

        if (index < guids.length) {
          queueMicrotask(processBatch); // 使用更轻量的异步方法
        } else {
          resolve({ gridKeyValue, unvalidData }); // 全部批次处理完毕后，返回结果
        }
      }

      processBatch().catch((error) => {
        console.error("绘制网格时出错：", error);
        reject(error);
      });
    });
  } catch (error) {
    console.error("绘制网格时出错：", error);
    return null;
  }
};

//绘制指定标准层的墙
export const drawStdFlrWallData = (
  wallSectData,
  wallData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  wallColor,
  originHeight,
  originLevelB,
  isSketchInit = false //是否是草图初始化
) => {
  try {
    if (!gridKeyValue || !wallSectData || !wallData) return null;

    // Create a map for faster section data lookup by Guid
    const wallSectMap = new Map(wallSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(wallData);
    let batchSize = 100; // 批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = wallData[guid];

          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            continue;
          }

          // Get corresponding section data
          let currSectData = wallSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将绘制数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 初始化墙体对象
          let rlWallObject = new rlWallData();
          rlWallObject.isWasmGeted = false;

          rlWallObject.initData({
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: {},
            points: null,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              B: currSectData.B,
              H: currSectData.H,
              Guid: currSectData.Guid,
            },
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            HDiffB: dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            StdFlrGuid: dataObj.StdFlrGuid,
            LevelB: currFlrLevelB + dataObj.HDiffB,
            Height: currFlrHeight - dataObj.HDiffB,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: wallColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
            CurrtSect: dataObj.CurrtSect,
          });

          rlWallObject.draw(); // 执行绘制操作
          promises.push(addEntityToDrawing(rlWallObject, true)); // 并发绘制

          // if (updateDatabase) {
          //   updateObjs.push(rlWallObject.getDataBase()); // 收集需要更新的数据
          // }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing walls:", error);
    return null;
  }
};

//绘制指定标准层的隔墙
export const drawStdFlrPartitionWallData = (
  partitionWallSectData,
  partitionWallData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  originHeight,
  originLevelB,
  isSketchInit = false //是否是草图初始化
) => {
  try {
    if (!partitionWallSectData || !partitionWallData) return null;

    // Create a map for faster section data lookup by Guid
    const partitionWallSectMap = new Map(
      partitionWallSectData.map((item) => [item.Guid, item])
    );

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; // 记录需要删除的数据
    let guids = Object.keys(partitionWallData);
    let batchSize = 100; // 批次大小
    let index = 0;
    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = partitionWallData[guid];

          // 如果网格数据为空或者其他数据为空，则跳过,
          if (
            !dataObj ||
            (dataObj.GridGuid &&
              (!gridKeyValue || !gridKeyValue[dataObj.GridGuid])) ||
            (!dataObj.GridGuid && !dataObj.OtherData)
          ) {
            continue;
          }

          // Get corresponding section data
          let currSectData = partitionWallSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            unvalidData.push(dataObj);
            continue;
          }

          // 初始化墙体对象
          let rlPartitionWallObject = new rlPartitionWallData();
          rlPartitionWallObject.isWasmGeted = false;
          let gridData = dataObj.GridGuid
            ? gridKeyValue[dataObj.GridGuid]
            : null;
          let partitionWallColor = getNonStructuralColor(dataObj.Mat);
          let spaceName = "";
          try {
            spaceName =
              dataObj.SpaceName && typeof dataObj.SpaceName !== "string"
                ? JSON.parse(dataObj.SpaceName)
                : "";
          } catch (error) {
            spaceName = "";
          }
          if (!gridData) continue;

          rlPartitionWallObject.initData({
            Guid: dataObj.Guid,
            index2dData: dataObj.Drawing_2D,
            index3dData: {},
            points: null,
            No_: dataObj.No_,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: dataObj.Mat,
              Kind: currSectData.Kind,
              B: currSectData.B,
              H: currSectData.H,
              Guid: currSectData.Guid,
            },
            partitionWallHeight:
              dataObj.Height == originHeight ? currFlrHeight : dataObj.Height, //dataObj.Height,
            Mat: dataObj.Mat,
            Ecc: dataObj.Ecc,
            Attribute: 0,
            StdFlrGuid: dataObj.StdFlrGuid,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            useFunctionNames: spaceName,
            m_gridData: gridData,
            Color: partitionWallColor,
            CurrtSect: dataObj.CurrtSect,
            OtherData: JSON.stringify(dataObj.OtherData),
            LinkGuids: dataObj.LinkGuids ? dataObj.LinkGuids?.split(",") : [],
          });

          rlPartitionWallObject.draw(); // 执行绘制操作
          promises.push(addEntityToDrawing(rlPartitionWallObject, true)); // 并发绘制

          // if (updateDatabase) {
          //   updateObjs.push(rlPartitionWallObject.getDataBase()); // 收集需要更新的数据
          // }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing PartitionWalls:", error);
    return null;
  }
};

//绘制指定标准层的梁
export const drawStdFlrBeamData = (
  beamSectData,
  beamData,
  gridKeyValue,
  currFlrHeight,
  currFlrLevelB,
  beamColor,
  subBeamColor,
  ringBeamColor,
  originHeight,
  originLevelB,
  isSketchInit = false //是否是草图初始化
) => {
  try {
    if (!gridKeyValue || !beamSectData || !beamData) return null;

    // Create a map for faster section data lookup by Guid
    const beamSectMap = new Map(beamSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(beamData);
    let batchSize = 100; // 批次大小
    let index = 0;

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = beamData[guid];

          if (!dataObj || !gridKeyValue || !gridKeyValue[dataObj.GridGuid]) {
            continue;
          }

          // Get corresponding section data
          let currSectData = beamSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // 初始化梁对象
          let rlBeamObject = new rlBeamData();
          rlBeamObject.isWasmGeted = false;

          rlBeamObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: {},
            points: null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
              IsRingBeamSeg: currSectData.IsRingBeamSeg,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            Rotation: dataObj.Rotation,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: currSectData.IsRingBeamSeg
              ? ringBeamColor
              : dataObj.Attribute == 1
              ? beamColor
              : subBeamColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
            CurrtSect: dataObj.CurrtSect,
            beamColor: beamColor,
            subBeamColor: subBeamColor,
            ringBeamColor: ringBeamColor,
            m_RelationGuid: dataObj.RelationGuid,
          });

          rlBeamObject.draw();
          promises.push(addEntityToDrawing(rlBeamObject, true)); // 并发绘制
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error in drawing beams:", error);
    return null;
  }
};

//绘制指定标准层的柱
export const drawStdFlrColData = (
  colSectData,
  colData,
  jointKeyValue,
  currFlrHeight,
  currFlrLevelB,
  colColor,
  originHeight,
  originLevelB,
  isSketchInit = false //是否是草图初始化
) => {
  try {
    if (!jointKeyValue || !colSectData || !colData) return null;

    // Create a map for faster section lookup
    const colSectMap = new Map(colSectData.map((item) => [item.Guid, item]));

    let updateObjs = []; // 记录需要在数据库更新的数据
    let unvalidData = []; //记录无效数据
    let guids = Object.keys(colData);
    let index = 0;
    let batchSize = 100; // 批次大小

    return new Promise((resolve) => {
      function processBatch() {
        let promises = [];
        let end = Math.min(index + batchSize, guids.length);

        for (; index < end; index++) {
          let guid = guids[index];
          let dataObj = colData[guid];

          if (!dataObj || !jointKeyValue[dataObj.JtGuid]) {
            continue;
          }

          let currSectData = colSectMap.get(dataObj.SectGuid);
          if (!currSectData) {
            //若找不到关联数据，将数据清空
            unvalidData.push(dataObj);
            continue;
          }

          // Parse OtherData and Drawing_3D if available
          let otherData = {};
          if (
            typeof dataObj.OtherData === "string" &&
            dataObj.OtherData !== ""
          ) {
            otherData = JSON.parse(dataObj.OtherData);
          } else {
            otherData = dataObj.OtherData;
          }
          // let drawing3DData = dataObj.Drawing_3D
          //   ? JSON.parse(dataObj.Drawing_3D)
          //   : null;
          // let updateModel3dData = drawing3DData ? false : true;

          // // 当层高变化时，重新计算顶点标高
          // if (
          //   originHeight &&
          //   originHeight !== currFlrHeight &&
          //   drawing3DData.points
          // ) {
          //   originLevelB = 0; // 初始化标高
          //   let points = drawing3DData.points;

          //   drawing3DData.points = points.map((item, index) => {
          //     if (index % 3 === 2) {
          //       // 处理 Z 轴上的顶点
          //       if (item === originLevelB) {
          //         item = currFlrLevelB;
          //       } else {
          //         item = item + currFlrHeight - originHeight;
          //       }
          //     }
          //     return item;
          //   });
          //   updateModel3dData = true;
          // }

          // let updateDrawing = false;
          // if (!updateModel3dData) {
          //   //判断截面尺寸是否修改
          //   let splitdata = currSectData.ShapeVal.split(",");
          //   let sectString = splitdata.splice(1, splitdata.length - 3);
          //   sectString = sectString.join("*");

          //   if (sectString != dataObj.CurrtSect) {
          //     updateModel3dData = true;
          //     updateDrawing = true;
          //   }
          // }

          // const updateDatabase =
          //   !drawing3DData || updateDrawing || updateModel3dData;
          // !(drawing3DData && !updateDrawing) || updateModel3dData;

          // 初始化柱对象
          let rlColumnObject = new rlColumnData();
          rlColumnObject.isWasmGeted = false;
          rlColumnObject.initData({
            Guid: dataObj.Guid,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: otherData,
            SectData: otherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: {},
            points: null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat,
              Kind: currSectData.Kind,
              ShapeVal: currSectData.ShapeVal,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: dataObj.StdFlrGuid,
            EccX: dataObj.EccX,
            EccY: dataObj.EccY,
            Rotation: dataObj.Rotation,
            HDiffB: dataObj.HDiffB,
            LevelB: currFlrLevelB,
            flrHeight: currFlrHeight,
            Height: currFlrHeight - dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_JointData: jointKeyValue[dataObj.JtGuid],
            Color: colColor,
            CurrtSect: dataObj.CurrtSect,
            m_RelationGuid: dataObj.RelationGuid,
          });

          rlColumnObject.draw();
          promises.push(addEntityToDrawing(rlColumnObject, true)); // 并发绘制

          // if (updateDatabase) {
          //   updateObjs.push(rlColumnObject.getDataBase());
          // }
        }

        // 等待当前批次的绘制操作完成
        Promise.all(promises).then(() => {
          if (index < guids.length) {
            queueMicrotask(processBatch); // 继续处理下一批数据
          } else {
            resolve({ updateObjs, unvalidData }); // 返回更新的数据
          }
        });
      }

      processBatch(); // 开始批次处理
    });
  } catch (error) {
    console.error("Error drawing columns:", error);
    return null;
  }
};

//绘制指定标准层数据--草图
export const drawStdFlrC = async (
  floorId,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("floorId不能为对象类型:", floorId);
      return;
    }

    // 拿到对应标准层
    var rlBuilding = store.state.cadModules.rlBuilding;
    var currFlrHeight = rlBuilding.Height ?? 3000; // 当前楼层的高度
    var currFlrLevelB = 0; //rlBuilding.LevelB ?? 0;
    store.commit("globalData/setIsBldg", false);

    // 调用绘制函数
    await drawFloorC(
      floorId,
      currFlrHeight,
      currFlrLevelB,
      originHeight,
      originLevelB
    );

    // FullView();
  } catch (error) {
    console.error("绘制楼层时出错：", error);
  }
};

// 整栋楼层数据设置
export const setTotalFloor = async (StdFlrGuid, Height, LevelB) => {
  // 获取构件的图层颜色
  const rlLayer = await getRlLayer();
  const [
    beamColor,
    wallColor,
    colColor,
    slabColor,
    ringBeamColor,
    subBeamColor,
    wallHoleColor,
  ] = await Promise.all([
    rlLayer.find((item) => item.Type === "rlBeamSeg"),
    rlLayer.find((item) => item.Type === "rlWallSeg"),
    rlLayer.find((item) => item.Type === "rlColSeg"),
    rlLayer.find((item) => item.Type === "rlSlabSeg"),
    rlLayer.find((item) => item.Type === "rlRingBeamSeg"),
    rlLayer.find((item) => item.Type === "rlSubBeam"),
    rlLayer.find((item) => item.Type === "rlWallHole"),
  ]);

  if (
    !beamColor ||
    !wallColor ||
    !colColor ||
    !slabColor ||
    !ringBeamColor ||
    !subBeamColor ||
    !wallHoleColor
  ) {
    return;
  }

  // 获取节点
  const jointKeyValue = await drawStdFlrJointData(StdFlrGuid, LevelB);

  // 获取柱数据并绘制
  const colData = await getRlModules("rlColSeg", StdFlrGuid);
  if (!colData) return null;

  for (const guid in colData) {
    const dataObj = colData[guid];
    if (dataObj) {
      if (typeof dataObj.OtherData === "string" && dataObj.OtherData !== "") {
        dataObj.OtherData = JSON.parse(dataObj.OtherData);
      }

      const rlColumnObject = new rlColumnData();
      rlColumnObject.isWasmGeted = true;
      rlColumnObject.initData({
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          ShapeVal: "",
          Guid: "",
        },
        Color: colColor.Color,
      });
      rlColumnObject.draw();
      await addEntityToDrawing(rlColumnObject, true);
    }
  }

  // 墙布置
  const wallData = await getRlModules("rlWallSeg", StdFlrGuid);
  if (!wallData) return null;

  for (const guid in wallData) {
    const dataObj = wallData[guid];
    if (dataObj) {
      if (typeof dataObj.OtherData === "string" && dataObj.OtherData !== "") {
        dataObj.OtherData = JSON.parse(dataObj.OtherData);
      }

      const rlWallObject = new rlWallData();
      rlWallObject.isWasmGeted = true;
      rlWallObject.initData({
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          B: "",
          H: "",
          Guid: "",
        },
        m_gridData: { m_wallId: "" },
        Color: wallColor.Color,
      });

      rlWallObject.draw();
      await addEntityToDrawing(rlWallObject, true);
    }
  }

  // 梁布置
  const beamData = await getRlModules("rlBeamSeg", StdFlrGuid);
  if (!beamData) return null;

  for (const guid in beamData) {
    const dataObj = beamData[guid];
    if (dataObj) {
      const rlBeamObject = new rlBeamData();
      rlBeamObject.isWasmGeted = true;
      rlBeamObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "",
          Kind: "",
          ShapeVal: "",
          Guid: "",
        },
        Color: beamColor.Color,
      });
      rlBeamObject.draw();
      await addEntityToDrawing(rlBeamObject, true);
    }
  }

  // 梁布置
  let circleBeamData = await getRlModules("rlRingBeamSeg", StdFlrGuid);
  if (!circleBeamData) return null;

  Object.keys(circleBeamData).forEach(async (guid) => {
    let dataObj = circleBeamData[guid];
    if (dataObj) {
      let rlBeamObject = new rlRingBeamData();
      rlBeamObject.isWasmGeted = true;
      rlBeamObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,

        m_sectParamData: {
          Name: "",
          Mat: "", //材质
          Kind: "", //截面类型
          ShapeVal: "", //截面尺寸
          Guid: "",
        },

        Color: ringBeamColor.Color,
      });
      rlBeamObject.draw();
      await addEntityToDrawing(rlBeamObject, true);
    }
  });

  //获取板布置数据
  let slabData = await getRlModules("rlSlab", StdFlrGuid);
  if (!slabData) return null;

  Object.keys(slabData).forEach(async (guid) => {
    let dataObj = slabData[guid];
    if (dataObj) {
      if (gridsObjs.length) {
        let rlSlabObject = new rlSlabData();
        rlSlabObject.isWasmGeted = true;
        rlSlabObject.initData({
          Guid: dataObj.Guid,
          index2dData: dataObj.Drawing_2D,
          index3dData: dataObj.Drawing_3D,
          points: dataObj.Drawing_3D
            ? JSON.parse(dataObj.Drawing_3D).points
            : null,
          m_sectParamData: {
            Kind: "",
            Mat: "",
            Thickness: "",
            Guid: "",
          },
          Color: slabColor,
        });
        rlSlabObject.draw();
        await addEntityToDrawing(rlSlabObject, true);
      }
    }
  });

  // 墙洞布置
  let rlWallHole = await getRlModules("rlWallHole", floorId);
  if (!rlWallHole) return null;

  Object.keys(rlWallHole).forEach(async (guid) => {
    let dataObj = rlWallHole[guid];
    if (dataObj) {
      let rlWallObject = new rlWallHoleData();
      rlWallObject.isWasmGeted = true;
      rlWallObject.initData({
        Guid: dataObj.Guid,
        index2dData: dataObj.Drawing_2D,
        index3dData: dataObj.Drawing_3D,
        points: dataObj.Drawing_3D
          ? JSON.parse(dataObj.Drawing_3D).points
          : null,
        m_sectParamData: {
          Name: "",
          Mat: "", //材质
          Kind: "", //截面类型
          B: "", //墙厚
          H: "",
          Guid: "",
        },
        Color: wallHoleColor,
      });
      rlWallObject.draw();
      await addEntityToDrawing(rlWallObject, true);
    }
  });
};

//绘制指定标准层的所有数据--草图
export const drawFloorC = async (
  floorId,
  currFlrHeight,
  currFlrLevelB,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("drawFloor: 无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("drawFloor: floorId不能为对象类型:", floorId);
      return;
    }

    let rlInitFloorData = await getRlInitFloorData(floorId);
    // 如果获取数据失败，则退出
    if (!rlInitFloorData) {
      console.error("获取楼层数据失败，floorId:", floorId);
      return;
    }

    //获取构件的图层颜色
    let rlLayer = rlInitFloorData.layerData;
    if (!rlLayer || !Array.isArray(rlLayer) || rlLayer.length === 0) {
      console.error("无效的图层数据:", rlLayer);
      return;
    }

    const rlLayerMap = rlLayer.reduce((acc, item) => {
      acc[item.Type] = item.Color;
      return acc;
    }, {});

    const beamColor = rlLayerMap["rlBeamSeg"];
    const wallColor = rlLayerMap["rlWallSeg"];
    const colColor = rlLayerMap["rlColSeg"];
    const slabColor = rlLayerMap["rlSlabSeg"];
    const ringBeamColor = rlLayerMap["rlRingBeamSeg"];
    const subBeamColor = rlLayerMap["rlSubBeam"];
    const wallHoleColor = rlLayerMap["rlWallHole"];
    const slabHoleColor = rlLayerMap["rlSlabHole"];

    if (
      !beamColor ||
      !wallColor ||
      !colColor ||
      !slabColor ||
      !ringBeamColor ||
      !subBeamColor ||
      !wallHoleColor
    )
      return;
    let stdFlrData = rlInitFloorData.stdFlrData;

    let isSketchInit = true;
    //绘制节点
    let jointKeyValue = await drawStdFlrJointCData(
      stdFlrData["rlJointC"],
      currFlrLevelB
    );

    let totalUpdateObjs = {}; //记录需要在数据库更新的数据
    let totalUnvalidData = {}; //记录无效数据
    //绘制轴线
    let axisKeyValue = {};
    // let axisResult = await drawStdFlrAxisCData(
    //   stdFlrData["rlAxisC"],
    //   jointKeyValue
    // );
    // axisKeyValue = axisResult ? axisResult.axisKeyValue : {};
    // if (axisResult && axisResult.unvalidData && axisResult.unvalidData.length) {
    //   totalUnvalidData["rlAxisC"] = axisResult.unvalidData;
    // }

    // if (store.state.displayData.axisDisplay) {
    //   toggleAxisDist(true);
    // }

    //绘制网格
    let gridKeyValue = {};
    let gridResult = await drawStdFlrGridCData(
      stdFlrData["rlGridC"],
      jointKeyValue,
      axisKeyValue
    );
    gridKeyValue = gridResult ? gridResult.gridKeyValue : {};
    if (gridResult && gridResult.unvalidData && gridResult.unvalidData.length) {
      totalUnvalidData["rlGridC"] = gridResult.unvalidData;
    }

    currFlrHeight = Number(currFlrHeight);
    currFlrLevelB = Number(currFlrLevelB);
    originHeight = Number(originHeight);
    originLevelB = Number(originLevelB);

    //获取梁截面
    let beamSectData = rlInitFloorData.beamSectData;
    let updateAndDelDatas = await drawStdFlrBeamData(
      beamSectData,
      stdFlrData["rlBeamSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      beamColor,
      subBeamColor,
      originHeight,
      originLevelB,
      isSketchInit
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlBeamSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlBeamSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取柱截面
    let colSectData = rlInitFloorData.colSectData;
    updateAndDelDatas = await drawStdFlrColData(
      colSectData,
      stdFlrData["rlColSeg"],
      jointKeyValue,
      currFlrHeight,
      currFlrLevelB,
      colColor,
      originHeight,
      originLevelB,
      isSketchInit
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlColSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlColSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取墙截面
    let wallSectData = rlInitFloorData.wallSectData;

    updateAndDelDatas = await drawStdFlrWallData(
      wallSectData,
      stdFlrData["rlWallSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      wallColor,
      originHeight,
      isSketchInit
    );
    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlWallSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlWallSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    //获取隔墙截面
    let PartitionWallSectData = rlInitFloorData.PartitionWallSectData;

    updateAndDelDatas = await drawStdFlrPartitionWallData(
      PartitionWallSectData,
      stdFlrData["rlPartitionWallSeg"],
      gridKeyValue,
      currFlrHeight,
      currFlrLevelB,
      originHeight,
      isSketchInit
    );

    if (
      updateAndDelDatas &&
      updateAndDelDatas.updateObjs &&
      updateAndDelDatas.updateObjs.length
    ) {
      totalUpdateObjs["rlPartitionWallSeg"] = updateAndDelDatas.updateObjs;
    }
    if (
      updateAndDelDatas &&
      updateAndDelDatas.unvalidData &&
      updateAndDelDatas.unvalidData.length
    ) {
      totalUnvalidData["rlPartitionWallSeg"] = updateAndDelDatas.unvalidData;
    }
    updateAndDelDatas = null;
    // await updateBulkRlStdFlrFieldDatas(floorId, totalUpdateObjs);
    await delBulkRlStdFlrFieldDatas(floorId, totalUnvalidData);

    rlAppObj.rlMxDrawObject.updateDisplay();
  } catch (error) {
    console.error("绘制楼层时出错：", error);
    // 可以根据需要处理错误
  }
};

//楼层复制---弃用
export const copyFloor = async (
  copyFloorNo,
  copyType /**1==>整层复制,3==>轴网复制，2==>局部复制 */,
  bChangeNow /*是否立即切换到新的标准层 */
) => {
  try {
    let allRlStdFlr = await getrlStdFlrAll();
    let lastNo = 0; //记录最后一个标准层No
    let totalData = null; //拷贝的源数据
    allRlStdFlr.forEach((item) => {
      if (item.No_ == copyFloorNo) {
        totalData = item;
      }
      if (lastNo < item.No_) {
        lastNo = item.No_;
      }
    });
    if (!totalData) return;

    //创建一个标准层
    let copyData = {};

    //整层复制
    if (copyType == 1) {
      copyData = JSON.parse(JSON.stringify(totalData));
      //给一个新的标准层guid
      copyData.Guid = generate_guid();
      copyData.No_ = lastNo + 1; //编号赋值--to do...

      //获取复制标准层中所有数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach(async (guid) => {
          let dataObj = jointData[guid];
          let rlPointObj = new rlJointData();
          rlPointObj.initData({
            m_pt: [dataObj["X"], dataObj["Y"], currFlrLevelB],
            StdFlrGuid: copyData.Guid,
          });
          await addEntityToDrawing(rlPointObj, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = rlPointObj.Guid;
          newJointData[rlPointObj.Guid] = rlPointObj;
        });
        copyData.rlJoint = newJointData;
      }

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach(async (guid) => {
          let dataObj = axisData[guid];
          let rlAxisObj = new rlAxisData();
          rlAxisObj.initData({
            m_stJoint: jointKeyValue[dataObj.Jt1Guid],
            m_edJoint: jointKeyValue[dataObj.Jt2Guid],
            IsMainAxis: dataObj.IsMainAxis,
            Name: dataObj.Name,
            StdFlrGuid: copyData.Guid,
          });
          await addEntityToDrawing(rlAxisObj, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          // dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = rlAxisObj.Guid;
          newAxisData[rlAxisObj.Guid] = rlAxisObj;
        });
        copyData.rlAxis = newAxisData;
      }

      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach(async (guid) => {
          let dataObj = gridData[guid];
          if (dataObj.Jt0Guid) {
            let rlLineGridObj = new rlGridArcData(); // 简化对象创建
            rlLineGridObj.initData({
              m_centerJoint: dataObj.Jt0Guid
                ? jointKeyValue[dataObj.Jt0Guid]
                : null,
              m_stJoint: jointKeyValue[dataObj.Jt1Guid],
              m_edJoint: jointKeyValue[dataObj.Jt2Guid],
              centerPoint: jointKeyValue[dataObj.Jt0Guid].m_pt,
              StdFlrGuid: copyData.Guid,
              m_Axis: axisKeyValue[dataObj.AxisGuid],
              Guid: dataObj.Guid,
            });
            await addEntityToDrawing(rlLineGridObj, true);
          } else {
            let rlLineGridObj = new rlGridData();
            rlLineGridObj.initData({
              m_stJoint: jointKeyValue[dataObj.Jt1Guid],
              m_edJoint: jointKeyValue[dataObj.Jt2Guid],
              StdFlrGuid: copyData.Guid,
              m_Axis: axisKeyValue[dataObj.AxisGuid],
            });
            await addEntityToDrawing(rlLineGridObj, true);
          }

          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          // dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          // dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = rlLineGridObj.Guid;
          newGridData[rlLineGridObj.Guid] = rlLineGridObj;
        });
        copyData.rlGrid = newGridData;
      }

      //墙
      let newWallData = {};
      let wallData = totalData.rlWallSeg;
      if (wallData) {
        Object.keys(wallData).forEach(async (guid) => {
          let dataObj = wallData[guid];
          let rlWallObject = new rlWallData();
          rlWallObject.isWasmGeted = true;
          rlWallObject.initData({
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            // index2dData: dataObj.Drawing_2D,
            // index3dData: dataObj.Drawing_3D
            //   ? JSON.parse(dataObj.Drawing_3D).faces
            //   : null,
            // index3dData: JSON.parse(dataObj.Drawing_3D),
            // points: dataObj.Drawing_3D
            //   ? JSON.parse(dataObj.Drawing_3D).points
            //   : null,
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              B: currSectData.B, //墙厚
              H: currSectData.H,
              Guid: currSectData.Guid,
            },

            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            HDiffB: dataObj.HDiffB,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            StdFlrGuid: copyData.Guid,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            //m_sectData: rlWallsectObject,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: wallColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
          });

          rlWallObject.draw();
          await addEntityToDrawing(rlWallObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
          newWallData[rlWallObject.Guid] = rlWallObject;
        });
        copyData.rlWallSeg = newWallData;
      }

      //梁
      let newBeamData = {};
      let beamData = totalData.rlBeamSeg;

      if (beamData) {
        Object.keys(beamData).forEach(async (guid) => {
          let dataObj = beamData[guid];
          let rlBeamObject = new rlBeamData();
          rlBeamObject.isWasmGeted = true;
          rlBeamObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              ShapeVal: currSectData.ShapeVal, //截面尺寸
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            Ecc: dataObj.Ecc,
            HDiff1: dataObj.HDiff1,
            HDiff2: dataObj.HDiff2,
            Rotation: dataObj.Rotation,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_gridData: gridKeyValue[dataObj.GridGuid],
            Color: beamColor,
            LinkGuids: dataObj.LinkGuids?.split(","),
          });
          rlBeamObject.draw();
          await addEntityToDrawing(rlBeamObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
          newBeamData[dataObj.Guid] = dataObj;
        });
        copyData.rlBeamSeg = newBeamData;
      }

      //柱
      let newColData = {};
      let colData = totalData.rlColSeg;
      if (colData) {
        Object.keys(colData).forEach(async (guid) => {
          let dataTmp = colData[guid];
          let rlColumnObject = new rlColumnData();
          rlColumnObject.isWasmGeted = true;
          rlColumnObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            Guid: dataObj.Guid,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Name: currSectData.Name,
              Mat: currSectData.Mat, //材质
              Kind: currSectData.Kind, //截面类型
              ShapeVal: currSectData.ShapeVal, //截面尺寸
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            EccX: dataObj.EccX,
            EccY: dataObj.EccY,
            Rotation: dataObj.Rotation,
            HDiffB: dataObj.HDiffB,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            m_JointData: jointKeyValue[dataObj.JtGuid],
            Color: colColor,
          });
          rlColumnObject.draw();
          await addEntityToDrawing(rlColumnObject, true);
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          // dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
          newColData[dataObj.Guid] = dataObj;
        });
        copyData.rlColSeg = newColData;
      }

      //板
      let newSlabData = {};
      let slabData = totalData.rlSlab;
      if (slabData) {
        Object.keys(slabData).forEach(async (guid) => {
          let dataObj = slabData[guid];
          // dataTmp.Guid = generate_guid();
          // dataTmp.StdFlrGuid = copyData.Guid;
          //切分后重新组合
          let splitGridsGuid = dataObj.GridsGuid.split(",");
          let newGridsGuid = "";
          splitGridsGuid.forEach((element) => {
            if (gridKeyValue[element]) {
              newGridsGuid += gridKeyValue[element];
              newGridsGuid += ",";
            }
          });

          // dataTmp.GridsGuid = newGridsGuid;

          let rlSlabObject = new rlSlabData();
          rlSlabObject.isWasmGeted = true;
          rlSlabObject.initData({
            No_: dataObj.No_,
            ModelNo: dataObj.ModelNo,
            OtherData: dataObj.OtherData,
            SectData: dataObj.OtherData.SectData,
            index2dData: dataObj.Drawing_2D,
            index3dData: dataObj.Drawing_3D,
            points: dataObj.Drawing_3D
              ? JSON.parse(dataObj.Drawing_3D).points
              : null,
            m_sectParamData: {
              Kind: currSectData.Kind,
              Mat: currSectData.Mat,
              Thickness: currSectData.Thickness,
              Guid: currSectData.Guid,
            },
            StdFlrGuid: copyData.Guid,
            Thickness: dataObj.Thickness,
            RoomlsHole: dataObj.RoomlsHole,
            VertexX: dataObj.VertexX,
            VertexY: dataObj.VertexY,
            VertexZ: dataObj.VertexZ,
            ParaVal: defaultThick,
            LevelB: currFlrLevelB,
            Height: currFlrHeight,
            Strength: dataObj.Strength,
            StrengthOther: dataObj.StrengthOther,
            Attribute: dataObj.Attribute,
            gridsObjs: newGridsGuid,
            Color: dataObj.Color,
          });
          rlSlabObject.draw();
          await addEntityToDrawing(rlSlabObject, true);

          newSlabData[rlSlabObject.Guid] = rlSlabObject;
        });
        copyData.rlSlab = newSlabData;
      }

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
        copyData.rlStdFlrPara = StdFlrParaData;
      }
    } else if (copyType == 3) {
      copyData.Guid = generate_guid();
      copyData.No_ = lastNo + 1;
      copyData.Height = totalData.Height;

      //获取复制标准层中所有的轴线、节点和网格数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlJoint = newJointData;
      }

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = dataTmp.Guid;
          newAxisData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlAxis = newAxisData;
      }

      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = dataTmp.Guid;
          newGridData[dataTmp.Guid] = dataTmp;
        });
        copyData.rlGrid = newGridData;
      }

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
        copyData.rlStdFlrPara = StdFlrParaData;
      }
    }

    //将复制数据写入indexdb
    await addrlStdFlr(copyData);
    //绘制
    if (bChangeNow) {
      //清空当前画布
      // rlAppObj.rlMxDrawObject.eraseAllMxEntity();
      clearDrawing();
      drawStdFlr(copyData.Guid);
      store.commit("globalData/setStdFlr", copyData.Guid);
    }
  } catch (error) {
    console.error("复制楼层时出错：", error);
  }
};

//切换标准层--草图
export const changeFloorC = async (
  floorId,
  originHeight = null,
  originLevelB = null
) => {
  try {
    // 验证floorId是否有效
    if (floorId === null || floorId === undefined) {
      console.error("changeFloor: 无效的floorId参数:", floorId);
      return;
    }

    // 将floorId确保为字符串类型，避免在IndexedDB查询时出错
    if (typeof floorId === "object") {
      console.error("changeFloor: floorId不能为对象类型:", floorId);
      return;
    }

    //清空当前画布
    await clearDrawing();
    showFullScreenLoading("模型加载中...");

    //清空已加载的轴线命名数据
    store.commit("globalData/clearGuidToRlAxisLineLoad");
    toggleAxisDist(false); //关闭轴线命名
    rlAppObj._rlMx.MxFun.updateDisplay();
    //

    await drawStdFlrC(floorId, originHeight, originLevelB);
    //

    //清空撤销回退数据
    await initRevokeReDoData();

    tryHideFullScreenLoading();
  } catch (error) {
    console.error("切换楼层时出错：", error);
    tryHideFullScreenLoading();
  }
};
// 楼层组装（整栋）
// export const drawTotalFloor = async () => {
//   try {
//     store.commit("globalData/setIsBldg", true);

//     await update3Dview();
//   } catch (error) {
//     console.error("楼层组装时出错：", error);
//   }
// };

export const clearDrawing = () => {
  try {
    if (store.state.rlEntData.totalEntityData) {
      //清空当前画布
      Object.keys(store.state.rlEntData.totalEntityData).forEach((key) => {
        let data = store.state.rlEntData.totalEntityData[key];
        for (let j = 0; j < data.length; j++) {
          let entity = data[j];
          if (entity) {
            if (
              entity.classTypeName == "rlColSeg" ||
              entity.classTypeName == "rlBeamSeg" ||
              entity.classTypeName == "rlSlab"
            ) {
              entity.eraseJcData();
            } else if (entity.classTypeName == "rlWallSeg") {
              entity.eraseJcData();
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlJoint") {
              entity.mcDbCircleIds.forEach((item) => {
                item.getMcDbEntity().erase();
              });
            } else if (entity.classTypeName == "rlJointC") {
              entity.mcDbCircleIds.forEach((item) => {
                item.getMcDbEntity().erase();
              });
            } else if (entity.classTypeName == "rlAxis") {
              entity.m_stText?.erase();
              entity.m_edText?.erase();
              entity.m_stLineTmp?.erase();
              entity.m_edLineTmp?.erase();
              entity.m_stCircle?.erase();
              entity.m_edCircle?.erase();
            } else if (entity.classTypeName == "rlAxisC") {
              entity.m_stText?.erase();
              entity.m_edText?.erase();
              entity.m_stLineTmp?.erase();
              entity.m_edLineTmp?.erase();
              entity.m_stCircle?.erase();
              entity.m_edCircle?.erase();
            } else if (entity.classTypeName == "rlDoorsWindows") {
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlWallHole") {
              entity.eraseOtherDraw();
            } else if (entity.classTypeName == "rlPartitionWallSeg") {
              entity.eraseOtherDraw();
            }
            entity.mcDbId?.getMcDbEntity()?.erase();
            if (entity.ModelType) {
              entity.m_TextObj?.erase();
              entity.StrengthTextObj?.erase();
              entity.ModelNoTextObj?.erase();
            }
          }
        }
      });
    }

    store.commit("rlEntData/clearEntityData");
    // rlAppObj.mxcadObject.newFile();
    // // del_all_entity_group();
    // rlAppObj.rlMxDatabase.getGroup("rlPointGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineAxisGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineGridGroup")?.clear();

    // rlAppObj.rlMxDatabase.getGroup("rlBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlColumnGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlWallGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSlabGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlLineGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlCircleGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlTextGroup")?.clear();

    // rlAppObj.rlMxDatabase.getGroup("rlWallHoleGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSubBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlRingBeamGroup")?.clear();
    // rlAppObj.rlMxDatabase.getGroup("rlSlabHole")?.clear();
  } catch (error) {
    console.error("清空画布时出错：", error);
  }
};

// -------------- 2024年6月5日新写
//楼层复制-自然层
export const copyStlFloor = async (
  totalData, // 标准层数据
  copyType /**1==>整层复制,3==>轴网复制，2==>局部复制 */,
  bChangeNow /*是否立即切换到新的标准层 */,
  addHeight /*新增标准层的层高*/
) => {
  try {
    let allRlStdFlr = await getrlStdFlrAll();
    let lastNo = 0; //记录最后一个标准层No
    if (allRlStdFlr.length > 0) {
      lastNo = Math.max(...allRlStdFlr.map((item) => item.No_));
    }
    //创建一个标准层
    let copyData = {};
    copyData.Guid = generate_guid(); //给一个新的标准层guid
    copyData.No_ = lastNo + 1;

    //整层复制
    if (copyType == 1) {
      //获取复制标准层中所有数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      const jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlJoint = newJointData;

      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      const axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (
            jointKeyValue[dataTmp.Jt1Guid] &&
            jointKeyValue[dataTmp.Jt2Guid]
          ) {
            dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
            dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
            axisKeyValue[guid] = dataTmp.Guid;
            newAxisData[dataTmp.Guid] = dataTmp;
          } else {
          }
        });
      }
      copyData.rlAxis = newAxisData;
      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      const gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);

      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (
            jointKeyValue[dataTmp.Jt1Guid] &&
            jointKeyValue[dataTmp.Jt2Guid] //&&
            //axisKeyValue[dataTmp.AxisGuid]
          ) {
            dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
            dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
            if (dataTmp.Jt0Guid) {
              dataTmp.Jt0Guid = jointKeyValue[dataTmp.Jt0Guid];
            }
            dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
            gridKeyValue[guid] = dataTmp.Guid;
            newGridData[dataTmp.Guid] = dataTmp;
          } else {
          }
        });
      }
      copyData.rlGrid = newGridData;

      //墙
      let newWallData = {};
      const wallData = totalData.rlWallSeg;
      if (wallData) {
        Object.keys(wallData).forEach((guid) => {
          let dataTmp = wallData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newWallData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlWallSeg = newWallData;

      //梁
      let newBeamData = {};
      const beamData = totalData.rlBeamSeg;

      if (beamData) {
        Object.keys(beamData).forEach((guid) => {
          let dataTmp = beamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newBeamData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlBeamSeg = newBeamData;

      //柱
      let newColData = {};
      const colData = totalData.rlColSeg;
      if (colData) {
        Object.keys(colData).forEach((guid) => {
          let dataTmp = colData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          if (jointKeyValue[dataTmp.JtGuid]) {
            dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
            newColData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlColSeg = newColData;

      //板
      let slabKeyValue = {};
      let newSlabData = {};
      const slabData = totalData.rlSlab;
      if (slabData) {
        Object.keys(slabData).forEach((guid) => {
          let dataTmp = slabData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.ModelNo = "";
          dataTmp.StdFlrGuid = copyData.Guid;
          //切分后重新组合
          let splitGridsGuid = dataTmp.GridsGuid.split(",");
          let newGridsGuid = "";
          splitGridsGuid.forEach((element) => {
            if (gridKeyValue[element]) {
              newGridsGuid += gridKeyValue[element];
              newGridsGuid += ",";
            }
          });

          dataTmp.GridsGuid = newGridsGuid;
          newSlabData[dataTmp.Guid] = dataTmp;
          slabKeyValue[guid] = dataTmp.Guid;
          // if (dataTmp.RoomIsHole)
        });
      }
      copyData.rlSlab = newSlabData;

      //隔墙
      let newSubWallData = {};
      let subWallKeyValue = {};
      const subWallData = totalData.rlPartitionWallSeg;
      if (subWallData) {
        Object.keys(subWallData).forEach((guid) => {
          let dataTmp = subWallData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newSubWallData[dataTmp.Guid] = dataTmp;
            subWallKeyValue[guid] = dataTmp.Guid;
          } else {
            newSubWallData[dataTmp.Guid] = dataTmp;
            subWallKeyValue[guid] = dataTmp.Guid;
          }
        });
      }
      copyData.rlPartitionWallSeg = newSubWallData;

      //墙洞
      let newWallHoleData = {};
      const wallHoleData = totalData.rlWallHole;
      if (wallHoleData) {
        Object.keys(wallHoleData).forEach((guid) => {
          let dataTmp = wallHoleData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (dataTmp.IsPartitionWall === 0 && gridKeyValue[dataTmp.GridGuid]) {
            dataTmp.GridGuid = gridKeyValue[dataTmp.GridGuid];
            newWallHoleData[dataTmp.Guid] = dataTmp;
          } else if (
            dataTmp.IsPartitionWall === 1 &&
            subWallKeyValue[dataTmp.GridGuid]
          ) {
            dataTmp.GridGuid = subWallKeyValue[dataTmp.GridGuid];
            newWallHoleData[dataTmp.Guid] = dataTmp;
          }
        });
      }

      copyData.rlWallHole = newWallHoleData;

      //板洞
      let newSlabHoleData = {};
      const slabHoleData = totalData.rlSlabHole;

      if (slabHoleData) {
        Object.keys(slabHoleData).forEach((guid) => {
          let dataTmp = slabHoleData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          if (jointKeyValue[dataTmp.JtGuid] && slabKeyValue[dataTmp.SlabGuid]) {
            dataTmp.JtGuid = jointKeyValue[dataTmp.JtGuid];
            dataTmp.SlabGuid = slabKeyValue[dataTmp.SlabGuid]; //关联楼板
            newSlabHoleData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlSlabHole = newSlabHoleData;

      //圈梁
      let newRingBeamData = {};
      const ringBeamData = totalData.rlRingBeamSeg;
      if (ringBeamData) {
        Object.keys(ringBeamData).forEach((guid) => {
          let dataTmp = ringBeamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlRingBeamSeg = newRingBeamData;

      //次梁
      let newSubBeamData = {};
      const subBeamData = totalData.rlSubBeam;
      if (subBeamData) {
        Object.keys(subBeamData).forEach((guid) => {
          let dataTmp = subBeamData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
        });
      }

      copyData.rlSubBeam = newSubBeamData;

      // //门窗
      // let newDoorWindowData = {};
      // const doorWindowData = totalData.rlDoorsWindows;
      // if (doorWindowData) {
      //   Object.keys(doorWindowData).forEach((guid) => {
      //     let dataTmp = doorWindowData[guid];
      //     dataTmp.Guid = generate_guid();
      //     dataTmp.StdFlrGuid = copyData.Guid;
      //     if (subWallKeyValue[dataTmp.GridGuid]) {
      //       dataTmp.GridGuid = subWallKeyValue[dataTmp.GridGuid];
      //       newDoorWindowData[dataTmp.Guid] = dataTmp;
      //     } else {
      //       newDoorWindowData[dataTmp.Guid] = dataTmp;
      //     }
      //   });
      // }

      // copyData.rlDoorsWindows = newDoorWindowData;
      //用途
      let newUsageData = {};
      const usageData = totalData.rlUse;
      if (usageData) {
        Object.keys(usageData).forEach((guid) => {
          let dataTmp = usageData[guid];
          // 如果points为空，则不复制
          if (dataTmp.Points != "{}") {
            dataTmp.Guid = generate_guid();
            dataTmp.StdFlrGuid = copyData.Guid;
            if (slabKeyValue[dataTmp.SlabGuid]) {
              dataTmp.SlabGuid = slabKeyValue[dataTmp.SlabGuid];
            }
            newUsageData[dataTmp.Guid] = dataTmp;
          }
        });
      }
      copyData.rlUse = newUsageData;
      //标准层参数
      const StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlStdFlrPara = StdFlrParaData;
    } else if (copyType == 3) {
      //获取复制标准层中所有的轴线、节点和网格数据
      let jointKeyValue = {};
      let newJointData = {};
      //获取节点
      let jointData = totalData.rlJoint; //await getRlModules("rlJoint", copyFloorId);
      if (jointData) {
        Object.keys(jointData).forEach((guid) => {
          let dataTmp = jointData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          jointKeyValue[guid] = dataTmp.Guid;
          newJointData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlJoint = newJointData;
      // 轴线
      let axisKeyValue = {};
      let newAxisData = {};
      let axisData = totalData.rlAxis; //await getRlModules("rlAxis", copyFloorId);
      if (axisData) {
        Object.keys(axisData).forEach((guid) => {
          let dataTmp = axisData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          axisKeyValue[guid] = dataTmp.Guid;
          newAxisData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlAxis = newAxisData;
      // 网格
      let gridKeyValue = {};
      let newGridData = {};
      let gridData = totalData.rlGrid; //await getRlModules("rlGrid", copyFloorId);
      if (gridData) {
        Object.keys(gridData).forEach((guid) => {
          let dataTmp = gridData[guid];
          dataTmp.Guid = generate_guid();
          dataTmp.StdFlrGuid = copyData.Guid;
          dataTmp.Jt1Guid = jointKeyValue[dataTmp.Jt1Guid];
          dataTmp.Jt2Guid = jointKeyValue[dataTmp.Jt2Guid];
          dataTmp.AxisGuid = axisKeyValue[dataTmp.AxisGuid];
          gridKeyValue[guid] = dataTmp.Guid;
          newGridData[dataTmp.Guid] = dataTmp;
        });
      }
      copyData.rlGrid = newGridData;

      //标准层参数
      let StdFlrParaData = totalData.rlStdFlrPara;
      if (StdFlrParaData) {
        StdFlrParaData.forEach((item) => {
          item.StdFlrGuid = copyData.Guid;
        });
      }
      copyData.rlStdFlrPara = StdFlrParaData;
    }
    // 单独设置层高度
    copyData.Height = addHeight ? +addHeight : totalData.Height;

    //将复制数据写入indexdb
    await addrlStdFlr(copyData);
    // 新增标准层的同时新增自然层
    //绘制
    if (bChangeNow) {
      //清空当前画布
      // rlAppObj.rlMxDrawObject.eraseAllMxEntity();
      clearDrawing();
      drawStdFlr(copyData.Guid);
      store.commit("globalData/setStdFlr", copyData.Guid);
    }

    return copyData;
  } catch (error) {
    console.error("复制楼层时出错：", error);
  }
};
